import { object, string } from "yup";

import { Button } from "components/DesignSystem/Button/Button";
import { FormikForm } from "components/FormikForm/FormikForm";
import Input from "components/DesignSystem/Input/Input";
import Modal from "components/DesignSystem/Modal/Modal";

type PasskeyNameFormValues = {
  device_name: string;
};

type PasskeyNameModalProps = {
  open: boolean;
  title: string;
  initialValue?: string;
  isSaving: boolean;
  onSubmit: (deviceName: string) => void;
  onCancel: () => void;
  secondaryAction?: { label: string; onClick: () => void };
};

const passkeyNameSchema = object({
  device_name: string().trim(),
});

export const PasskeyNameModal = ({
  open,
  title,
  initialValue = "",
  isSaving,
  onSubmit,
  onCancel,
  secondaryAction,
}: PasskeyNameModalProps) => {
  const handleSubmit = ({ device_name }: PasskeyNameFormValues) => {
    onSubmit(device_name);
  };

  return (
    <Modal.Root open={open} onOpenChange={(next) => !next && onCancel()}>
      <Modal.Content useCustomOverlay size="small">
        <FormikForm<PasskeyNameFormValues>
          initialValues={{ device_name: initialValue }}
          enableReinitialize
          onSubmit={handleSubmit}
          validationSchema={passkeyNameSchema}
        >
          {({ values }) => (
            <>
              <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Input
                  withForm
                  name="device_name"
                  placeholder="e.g. MacBook Touch ID"
                  label="Passkey name"
                />
              </Modal.Body>
              <Modal.FooterButtonGroup>
                {secondaryAction && (
                  <Button
                    customType="secondary"
                    type="button"
                    onClick={secondaryAction.onClick}
                    disabled={isSaving}
                  >
                    {secondaryAction.label}
                  </Button>
                )}
                <Button
                  customType="primary"
                  type="submit"
                  isLoading={isSaving}
                  disabled={isSaving || !values.device_name.trim()}
                >
                  Save
                </Button>
              </Modal.FooterButtonGroup>
            </>
          )}
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
